import { useMutation } from "@apollo/client";
import { Card } from "@blueprintjs/core";
import { ArticleCategory, UpdateArticleInput } from "../../api/schema";
import { FlexBox, FlexRowStretch } from "../../components/flex/Flex";
import { ModalInputType } from "../../components/form/Form";
import { ViewHeader } from "../../components/form/Header";
import {
  InputForm,
  InputFormMode,
  ValuesVariables,
} from "../../components/form/InputForm";
import { FormInputFields } from "../../components/form/InputFormBuilder";
import { UserLanguage } from "../../lang/lang";
import {
  UpdateArticleCategoryMutation,
  UpdateArticleCategoryResponse,
} from "./graphql";
import { KeyFieldListView } from "./KeyFieldList";

const UpdateModalKeys: FormInputFields<ArticleCategory> = {
  id: {
    type: ModalInputType.String,
    readonly: true,
    label: UserLanguage().data.id,
  },
  name: {
    type: ModalInputType.String,
    icon: "id-number",
    label: UserLanguage().data.name,
    translate: UserLanguage().data.article_categories,
  },
};

export const ArticleCategoryView = (props: {
  articleCategory: ArticleCategory;
  refetch: () => void;
}) => {
  console.log("data", props.articleCategory);

  const [updateArticleCategory] = useMutation<
    UpdateArticleCategoryResponse,
    ValuesVariables<UpdateArticleInput>
  >(UpdateArticleCategoryMutation);

  return (
    <div style={{ width: 1200 }}>
      <FlexRowStretch>
        <FlexBox>
          <Card elevation={3}>
            <ViewHeader
              title={
                UserLanguage().pages.articleCategory.label +
                " - " +
                props.articleCategory.id
              }
            />
            <InputForm<ArticleCategory>
              input={props.articleCategory}
              mode={InputFormMode.Edit}
              onSuccess={() => props.refetch()}
              mutation={updateArticleCategory}
              keys={UpdateModalKeys}
              texts={UserLanguage().pages.articleCategory.actions}
            />
          </Card>
        </FlexBox>
        <div style={{ flex: "flex-grow", minWidth: "20px" }} />
        <FlexBox>
          <KeyFieldListView
            articleCategory={props.articleCategory}
            keyFields={props.articleCategory.fields}
            refetch={() => props.refetch()}
          />
        </FlexBox>
      </FlexRowStretch>
    </div>
  );
};
